module.exports = __webpack_public_path__ + "img/generic-faliure.54c2f27a.png";